import styled from 'styled-components'

const Wrapper = styled.div`
  padding-top: 5px;
`;

export default Wrapper;